import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from 'src/app/config';
import { PdfZaIzdatniceLotSirovinaPojedinacnoService } from 'src/app/pdf-ovi/pdfZaIzdatniceLotSirovinaPojedinacno.service';
import { LotNaljepniceService } from './lot-naljepnice.service';

@Component({
  selector: 'app-lot-naljepnice',
  templateUrl: './lot-naljepnice.component.html',
  styleUrls: ['./lot-naljepnice.component.scss'],
})
export class LotNaljepniceComponent implements OnInit {
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');

  skladistaSirovina: any = [];
  stavkeIzdatnicaLotSirovina: any = [];

  idOdabranogSkladistaSirovina: any;
  nazivOdabranogSkladistaSirovina: any;
  sifraOdabranogSkladistaSirovina: any;
  access_token: any;
  zavrseniNalozi: boolean = false;

  pdfButton: any;

  stavkeIzdatnicaLotSirovinaPojedinacno: any = [];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private service: LotNaljepniceService,
    private pdfZaIzdatniceLotSirovinaPojedinacnoService: PdfZaIzdatniceLotSirovinaPojedinacnoService
  ) {
    this.access_token = sessionStorage.getItem('token');

    this.dohvatiSkladistaSirovina();
    this.dohvatiIzvjestajeLotNaljepnica();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().lotNaljepnice;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSkladistaSirovina();
    this.dohvatiIzvjestajeLotNaljepnica();
  }

  dohvatiSkladistaSirovina() {
    this.skladistaSirovina = [];

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser'),
    };
    // console.log('PODACI ZA SLANJE:  ', podaciZaSlanje);

    this.service.dohvatiSkladistaSirovina(podaciZaSlanje).subscribe((res) => {
      // console.log('SKLADISTA SIROVINA: ', res);
      if (res.success === true) {
        this.skladistaSirovina = res.data;
      }
    });
  }

  dohvatiIzvjestajeLotNaljepnica() {
    this.stavkeIzdatnicaLotSirovina = [];

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser'),
      idposlovnica: this.idOdabranogSkladistaSirovina,
      po_sifra: this.sifraOdabranogSkladistaSirovina,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      access_token: this.access_token,
      zavrsen_nalog: this.zavrseniNalozi,
    };
    //console.log('PODACI ZA SLANJE:  ', podaciZaSlanje);

    this.service.dohvatiIzvjestajeLotNaljepnica(podaciZaSlanje).subscribe((res) => {
      //console.log('IZVJEŠTAJI SIROVINA: ', res);
      if (res.success === true) {
        this.stavkeIzdatnicaLotSirovina = res.data;
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    // console.log('DATUM OD: ', this.datumOd);
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestajeLotNaljepnica();
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    // console.log('DATUM DO: ', this.datumDo);
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestajeLotNaljepnica();
  }

  onChangeSkladisteSirovina(e) {
    this.idOdabranogSkladistaSirovina = e.value.idposlovnica;
    this.nazivOdabranogSkladistaSirovina = e.value.po_naziv;
    this.sifraOdabranogSkladistaSirovina = e.value.po_sifra;
    this.dohvatiIzvjestajeLotNaljepnica();
  }

  onChangeZavrseniNalozi(e) {
    this.zavrseniNalozi = e.value;
    // console.log('ZAVRŠENI NALOZI: ', this.zavrseniNalozi);

    this.dohvatiIzvjestajeLotNaljepnica();
  }

  pdfIzdatnicaLotSirovinaSkupno() {
    //console.log('TU SAM');
  }

  pdfIzdatnicaLotSirovinaPojedinacno(data) {

    this.stavkeIzdatnicaLotSirovinaPojedinacno = [];
    this.stavkeIzdatnicaLotSirovinaPojedinacno = data.data;
    // console.log('STAVKE:  ', this.stavkeIzdatnicaLotSirovinaPojedinacno);

    this.pdfZaIzdatniceLotSirovinaPojedinacnoService.pdfZaIzdatniceLotSirovinPojedinacnoService(
      this.stavkeIzdatnicaLotSirovinaPojedinacno
    );
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
